import React, { Component } from 'react';
import * as apiServices from '../../services/apiServices';
import { toast } from 'react-toastify';
import * as Constants from '../../core/constants';

const searchController = (
  WrapperComponent,
  endpoint,
  params,
  ) => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.afterQuery = false;
      this.timerId = null;
      this.isFetching = false;
      this.state = {
        searchQuery: '',
        selectQuery: [],
        inputValue: '',
        selectValues: {},
        clearAllEnabled: false,
        prevQuery: '',
        page: Constants.START_PAGE_DEFAULT,
        perPage: props.perPage ? props.perPage : Constants.PER_PAGE_DEFAULT,
      };
    }
    componentDidMount() {
      const {trainer}  = JSON.parse(localStorage.getItem("trainer")) || {};
      if (trainer?.length) {
        this.setState((prevState) => {
          return {
            ...prevState,
            selectValues: {trainer},
            clearAllEnabled: true,
          }
        });
        let mockQuery = []
        const query = this.queryBuilder("trainer", trainer);
        mockQuery.push(query.toString())
        
        this.combineQuery("", mockQuery);
      }
    }

    componentWillUnmount() {
      clearTimeout(this.timerId);
    }

    inputUpdate = text => {
      const { selectQuery } = this.state;
      const query = this.queryBuilder('q',text);
      this.props.base();
      this.setState({
        searchQuery: query,
        inputValue: text,
        page: Constants.START_PAGE_DEFAULT,
        clearAllEnabled: text.length ? true : false,
      });
      this.combineQuery(query, selectQuery);
    }
    
    selectUpdate = (type, array) => {
      const { searchQuery, selectQuery, selectValues } = this.state;
      const mockQuery = [...selectQuery];
      let selectValuesCopy = Object.assign({}, selectValues);
      let updateExisting = false;
      
      const query = this.queryBuilder(type, array.length > 0 ? array : null);
      for (let i = 0; i < mockQuery.length; i++) {
        const item = mockQuery[i]
        if (item.includes(type)) {
          if (!query) {
            mockQuery.splice(i,1);
          } else {
            mockQuery[i] = query;
          }
          updateExisting = true;
          break;
        }
      }
      if (!updateExisting) {
        mockQuery.push(query)
      }
      this.props.base();
      selectValuesCopy[type] = array;
      if(selectValuesCopy) {
        localStorage.setItem("trainer", JSON.stringify(selectValuesCopy))
      }
      this.setState({
        selectQuery: mockQuery,
        selectValues: selectValuesCopy,
        page: Constants.START_PAGE_DEFAULT,
        clearAllEnabled: true,
      });
      this.combineQuery(searchQuery, mockQuery);
    }

    clearAll = () => {
      const { clearAllEnabled } = this.state;
      localStorage.setItem("trainer", JSON.stringify({trainer: null}))
      this.props.base();
      if (clearAllEnabled) {
        this.setState({
          searchQuery: '',
          selectQuery: [],
          inputValue: '',
          selectValues: {},
          clearAllEnabled: false,
        });
        this.combineQuery('', []);
      }
    }

    combineQuery = (search, select) => {
      let fullQuery = "";
      if(search && select.length > 0) {
        fullQuery = search + "&" + select.join('&');
      } else {
        fullQuery = search + select.join('&');
      }
      this.delayInput(fullQuery);
    }

    queryBuilder = (param, value) => {
      if (!value) {
        return '';
      } else if (Array.isArray(value)) {
        return `${ param }=${ value.map(item => item.value).join(',').toLowerCase() }`;
      } else {
        return `${ param }=${ value.toLowerCase() }`;
      }
    }

    delayInput = query => {
      if(!this.afterQuery) {
        this.props.getter();
      }
      this.afterQuery = true;
      clearTimeout(this.timerId);
      this.timerId = setTimeout(async () => this.fetchQuery(query), 500)
    };
    
    fetchQuery = async query => {
      const { page, perPage } = this.state;
      this.afterQuery = false;
      apiServices.query(endpoint, query, { params: Object.assign(params.params, { page, page_size: perPage })})
      .then(response => {
        if(!this.afterQuery) {
          this.props.setter(response.results, response.count, query);
          this.setState({prevQuery: query}, () => this.isFetching = false)
        }
      })
      .catch(e => {
        console.log('component: ',this,e);
        toast.error(e.message);
      })
    }

    render() {
      const { prevQuery, page } = this.state;

      if(this.props.gotoNext && !this.isFetching) {
        this.isFetching = true;
        this.setState({page: page + 1},() => this.delayInput(prevQuery))
      }
      return ( 
        <WrapperComponent
          inputValue={this.state.inputValue}
          selectValues={this.state.selectValues}
          onInputChange={this.inputUpdate}
          onSelectChange={this.selectUpdate}
          onClearAll={this.clearAll}
          clearAllEnabled={this.state.clearAllEnabled}
          endpoint={endpoint}
          {...params}
          {...this.props}
        />
      )
    }
  }
}

export default searchController;
